import { render, staticRenderFns } from "./DataLoadHeader.vue?vue&type=template&id=e35f61e8&"
import script from "./DataLoadHeader.vue?vue&type=script&lang=js&"
export * from "./DataLoadHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports